var fitt = require('fitt'),
forEach = fitt.forEach,
cstr = fitt.cstr,
trim = fitt.trim,
strlc = fitt.strlc;

/**
                     * Parse headers into an object
                     *
                     * ```
                     * Date: Wed, 27 Aug 2014 08:58:49 GMT
                     * Content-Type: application/json
                     * Connection: keep-alive
                     * Transfer-Encoding: chunked
                     * ```
                     *
                     * @param {String} headers Headers needing to be parsed
                     * @returns {Object} Headers parsed into an object
                     */
function parseHeaders(headers) {
  var parsed = {},
  parsedItem,
  key,
  val,
  i;

  headers = cstr(headers);

  if (headers) {
    forEach(headers.split('\n'), function parser(line) {
      i = line ? line.indexOf(':') : -1;
      if (i != -1) {
        key = strlc(trim(line.substr(0, i)));
        val = trim(line.substr(i + 1));

        if (key) {
          parsedItem = parsed[key];
          parsed[key] = parsedItem ? parsedItem + ', ' + val : val;
        }
      }
    });
  }

  return parsed;
}

/**
   * Create an Error with the specified message, config, error code, and response.
   *
   * @param {string} message The error message.
   * @param {string} url The URL being requested.
   * @param {Object} config The config.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {number} [status] The response status (for example, 404).
   * @param {string|Object} [data] Response data.
   * @returns {Error} The created error.
   */
function createError(message, url, config, code, status, data) {
  var error = new Error(message);

  error.config = config;
  error.url = url;

  if (code) {
    error.code = code;
  }

  if (status) {
    error.status = status;
  }

  if (data) {
    error.data = data;
  }

  return error;
}

if (typeof module !== 'undefined') {
  module.exports = {
    parseHeaders: parseHeaders,
    createError: createError };

}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/core/utils.js
// module id = 785
// module chunks = 0